export default "__VITE_ASSET__84bdd0de__"